// React Component (or JSX)

import React from 'react';
import './App.css'; // Assuming you have a CSS file for styles

const Cédric_Luthi_0xced_PR_Arcenox_co_TickerQ_pull_169_From_2025_08_01_To_2025_08_31_Target_NET_8_and_NET_9 = () => {
  return (
    <>
     <a
        href="https://github.com/0xced?tab=overview&from=2025-08-01&to=2025-08-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from Aug 1, 2025 to Aug 31, 2025
      </a>
<div>
<a
        href="https://github.com/0xced?tab=overview&from=2025-08-01&to=2025-08-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/0xced?tab=overview&from=2025-08-01&to=2025-08-31
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
>
<bdi className="js-issue-title markdown-title">Target .NET 8 and .NET 9</bdi>

  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/JuliaNLSolvers/Optim.jl/pull/1084" target="_blank" rel="noopener noreferrer">
  #169
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/0xced" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">Cédric Luthi</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/JuliaNLSolvers/Optim.jl/pull/1084" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Aug 13, 2025</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>

<p>Here are the details of a specific commit from the <a href="https://github.com/Arcenox-co/TickerQ" target="_blank">Arcenox-co/TickerQ repository</a>:</p>

  </>
  );
};

export default Cédric_Luthi_0xced_PR_Arcenox_co_TickerQ_pull_169_From_2025_08_01_To_2025_08_31_Target_NET_8_and_NET_9;
